import axios from 'axios';
import {getEnvVar} from '@/library/utils/env-vars';
import {PLATAFORMA} from '@/config'

function calcularValidez(fecha){
	let rn = new Date();
	let fechaEOL = new Date(fecha);
	return fechaEOL>rn;
}

const codsEstadosVersion = {
	NO_RELEASE: 'COD_NO_RELEASE',
	EOL: 'COD_EOL',
	OUTDATED: 'COD_OUTDATED'
};

const COD_ACCIONES = {
	RELEASE: 1,
	OUTDATED: 2,
	EOL: 3,
}


export default {
	async checkVersion({commit, getters}, payload){

		let api = getEnvVar('API_CHECK_VERSION');
		let {version}= await import('@/version');
		
		api = api.replace(':PLAT', PLATAFORMA);

		commit('GET_VERSION', version);

		try{
			let {data={}} = await axios.get(api, {params:{version}});
			
			let {action:{fecha, accion}={}} = data;

			let filterAcciones = function(accion, cod, fecha){
				
				let esCod = accion.accion == cod;
				accion.fecha = !accion.fecha?accion.fecha : accion.fecha.replace(/-/g, '/');
				let fechaValida = new Date(accion.fecha) <= new Date();
				return esCod && fechaValida;
			}

			let acciones = data.acciones;
			let accionRelease = acciones.filter(a=>filterAcciones(a, COD_ACCIONES.RELEASE))[0];
			let proxRelease = acciones.filter(a=>a.accion==COD_ACCIONES.RELEASE)[0];
			let accionOutdated = acciones.filter(a=>filterAcciones(a, COD_ACCIONES.OUTDATED))[0];
			let accionEoL = acciones.filter(a=>a.accion==COD_ACCIONES.EOL)[0];

			data = {
				isValid: false,
				action: proxRelease,
				COD_MSG: codsEstadosVersion.NO_RELEASE
			};
			
			// en caso de que no haya release oficial se impide que el usuario pueda seguir
			if( accionRelease==null ){
				
				data = {
					isValid: false,
					action: proxRelease,
					COD_MSG: codsEstadosVersion.NO_RELEASE
				};
			}else if( !!accionEoL && !checkVersionEOL(accionEoL||{}) ){
			// en caso de no tener eol se considera que aun esta vigente la version
			
				// en caso de que haya vencido el eol se evita el ingreso
					data = {
						isValid: false,
						action: accionEoL,
						COD_MSG: codsEstadosVersion.EOL
					}
			// en caso de que la version tenga fecha de outdated se checkea si se debe
			// o no enviar mensaje
			}else if( !!accionOutdated ){
				
				data = {
					isValid: true,
					action: accionOutdated,
					eol:accionEoL
				};
				
				let upToDate = checkVersionOutdated(accionOutdated);
				
				if(!upToDate){
					data = {
						isValid: true,
						action: accionOutdated,
						COD_MSG: codsEstadosVersion.OUTDATED,
						upToDate,
						eol:accionEoL
					};
				}
				
			// en caso de no tener eol se considera que aun esta vigente la version
			}else{
				
				data = {
					isValid: true,
					action: accionRelease,
				};
			}

			let isValid = data.isValid;
			let isUpToDate = data.upToDate !== false;

			commit('SET_VERSION', data);
			if( isValid && !!isUpToDate ){
				return data;
			}else{
				commit('SET_VERSION_ERROR', data);
				throw data;
			}
		}catch(err){
			commit('SET_VERSION_ERROR', err);
			throw 'Ha ocurrido un error al verificar la versión.'
		}
	},
	async resetEstados({state}, payload){
		state.lastCall = undefined;
		state.error = undefined;
	}
}


function checkVersionEOL({fecha}){
	let rn = new Date();
	let fechaEOL = new Date(fecha);
	
	return fechaEOL>rn;
}

function checkVersionOutdated ({fecha}){
	let rn = new Date();
	let fechaEOL = new Date(fecha);
	
	return fechaEOL>rn;
}

function getDateVersionFromObject({fecha}){
	
}